import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentMethodCreditsDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 32,
	viewBox: "0 0 48 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4745_421)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z",
				fill: "url(#paint0_linear_4745_421)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 0.25H44C46.0711 0.25 47.75 1.92893 47.75 4V28C47.75 30.0711 46.0711 31.75 44 31.75H4C1.92893 31.75 0.25 30.0711 0.25 28V4C0.25 1.92893 1.92893 0.25 4 0.25Z",
				stroke: "#FFA63D",
				strokeOpacity: .32,
				strokeWidth: .5
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.5437 17.0534C18.0637 16.9734 17.5837 16.8634 17.1037 16.7334C16.5537 16.5734 16.0237 16.3434 15.5137 15.9934C15.4237 15.9234 15.3237 15.8534 15.2037 15.7734C15.2037 15.8334 15.2137 17.6534 15.2037 18.5134C15.1937 18.9234 15.3237 19.2234 15.5537 19.4734C15.8137 19.7534 16.1237 19.9534 16.4437 20.1134C17.0037 20.3934 17.5937 20.5734 18.2037 20.6934C18.7737 20.8034 19.3437 20.8734 19.9237 20.8934C20.2537 20.9034 20.5837 20.9034 20.9137 20.8834V20.7234L20.9037 19.2034V19.1434C20.9037 19.0134 20.9137 18.8534 20.9037 18.6834C20.9137 18.4034 20.9137 18.0834 20.9137 17.7734V17.1734C20.6937 17.1934 20.4637 17.1934 20.2437 17.1934C19.6737 17.1934 19.1037 17.1534 18.5437 17.0534Z",
				fill: "#FFA63D"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.7336 11.9933C18.1236 11.9033 17.5236 11.7733 16.9236 11.5733C16.4536 11.4233 15.9936 11.2233 15.5636 10.9333C15.4536 10.8533 15.3336 10.7633 15.2036 10.6733C15.2036 10.7333 15.2136 12.5733 15.2036 13.4533C15.2036 13.7833 15.2936 14.0533 15.4736 14.2833C15.7536 14.6233 16.0836 14.8333 16.4336 15.0133C16.9436 15.2833 17.4736 15.4433 18.0136 15.5633C18.5336 15.6833 19.0636 15.7633 19.6036 15.7933C20.0436 15.8233 20.4836 15.8333 20.9136 15.8133L20.9036 13.5433L20.9336 13.5633C20.8836 13.1433 20.9436 12.6133 21.2636 12.0633C20.4236 12.1333 19.5736 12.1033 18.7336 11.9933Z",
				fill: "#FFA63D"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M15.5411 9.28293C15.8401 9.62093 16.1951 9.82993 16.5631 10.0049C17.2261 10.3199 17.9161 10.4929 18.6161 10.6049C19.2061 10.6989 19.8001 10.7469 20.2781 10.7379C21.3951 10.7399 22.3851 10.6289 23.3601 10.3379C23.8461 10.1929 24.3201 10.0039 24.7651 9.70593C25.0091 9.54193 25.2371 9.34993 25.4131 9.07093C25.6471 8.70093 25.6501 8.26993 25.4131 7.90493C25.3321 7.77993 25.2381 7.66493 25.1371 7.56693C24.7591 7.20093 24.3231 6.98793 23.8751 6.81193C23.0781 6.49893 22.2581 6.34593 21.4291 6.27593C20.2991 6.18093 19.1721 6.22893 18.0531 6.47593C17.4451 6.60893 16.8491 6.79593 16.2821 7.11293C15.9791 7.28193 15.6901 7.48293 15.4581 7.79293C15.2651 8.05093 15.1521 8.34493 15.2331 8.71293C15.2851 8.94693 15.4021 9.12593 15.5411 9.28293Z",
				fill: "#FFA63D"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M32.7945 20.6172C32.7526 20.6492 32.7304 20.6672 32.7076 20.6812C32.4635 20.8382 32.2256 21.0142 31.9726 21.1462C31.0796 21.6152 30.1406 21.8342 29.1856 21.9622C28.6066 22.0402 28.0266 22.0652 27.4446 22.0602C26.8745 22.0562 26.3066 22.0212 25.7436 21.9222C25.2645 21.8372 24.7866 21.7262 24.3126 21.5962C23.7596 21.4422 23.2236 21.2112 22.7226 20.8612C22.6236 20.7912 22.5245 20.7182 22.4105 20.6362C22.4105 20.6962 22.4196 22.5162 22.4076 23.3842C22.4016 23.7872 22.5296 24.0852 22.7566 24.3352C23.0196 24.6252 23.3246 24.8182 23.6436 24.9792C24.2126 25.2642 24.8025 25.4352 25.4035 25.5582C25.9745 25.6742 26.5476 25.7392 27.1235 25.7602C28.1165 25.7962 29.1045 25.7282 30.0835 25.4972C30.6465 25.3642 31.1986 25.1852 31.7236 24.8892C32.0236 24.7202 32.3085 24.5202 32.5406 24.2152C32.7106 23.9922 32.7996 23.7332 32.7966 23.4132C32.7906 22.5282 32.7945 20.6812 32.7945 20.6172Z",
				fill: "#FFA63D"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M22.681 19.15C22.953 19.491 23.286 19.704 23.634 19.883C24.144 20.145 24.674 20.31 25.214 20.433C25.741 20.554 26.272 20.628 26.806 20.663C27.838 20.73 28.865 20.675 29.886 20.458C30.507 20.325 31.117 20.138 31.697 19.817C32.007 19.646 32.303 19.441 32.543 19.126C32.71 18.906 32.799 18.651 32.797 18.333C32.79 17.442 32.791 15.589 32.789 15.544C32.671 15.628 32.567 15.709 32.458 15.781C31.617 16.345 30.705 16.604 29.775 16.771C29.342 16.849 28.905 16.895 28.468 16.932C27.623 17.003 26.779 16.97 25.937 16.857C25.328 16.775 24.724 16.644 24.131 16.444C23.66 16.287 23.202 16.091 22.771 15.798C22.655 15.718 22.541 15.633 22.411 15.54C22.411 15.599 22.416 17.439 22.408 18.317C22.405 18.654 22.499 18.922 22.681 19.15Z",
				fill: "#FFA63D"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M23.4862 11.9801C23.1832 12.1491 22.8952 12.3501 22.6632 12.6601C22.4702 12.9171 22.3562 13.2111 22.4382 13.5801C22.4892 13.8131 22.6072 13.9931 22.7452 14.1501C23.0442 14.4871 23.3992 14.6971 23.7672 14.8721C24.4312 15.1871 25.1212 15.3601 25.8202 15.4721C26.4112 15.5661 27.0042 15.6141 27.4822 15.6051C28.5992 15.6071 29.5892 15.4951 30.5642 15.2051C31.0502 15.0601 31.5252 14.8701 31.9692 14.5721C32.2132 14.4091 32.4422 14.2171 32.6182 13.9381C32.8512 13.5671 32.8552 13.1371 32.6182 12.7721C32.5362 12.6471 32.4422 12.5321 32.3412 12.4341C31.9632 12.0671 31.5272 11.8541 31.0792 11.6791C30.2822 11.3661 29.4622 11.2121 28.6342 11.1431C27.5032 11.0471 26.3762 11.0961 25.2572 11.3421C24.6502 11.4761 24.0532 11.6631 23.4862 11.9801Z",
				fill: "#FFA63D"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_4745_421",
		x1: 0,
		y1: 0,
		x2: 48,
		y2: 32,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			stopColor: "#FFA63D",
			stopOpacity: .12
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FFA63D",
			stopOpacity: .24
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4745_421",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 32,
			fill: "white"
		})
	})] })]
});
export default SvgPaymentMethodCreditsDark;
